
//REACT
import React from 'react';

//REDUX
import {persistor} from "../../../store";
import {offCanvasReset} from "../../../Features/Misc/offCanvasSlice";
import {navBarReset} from "../../../Features/Misc/navBarSlice";
import {activeMediaReset, activeReset} from "../../../Features/Misc/activeSlice";
import {useDispatch} from "react-redux";
import {logOut, purgeID, reset} from "../../../Features/Auth/authSlice";

//ANIMATE
import { Animate, AnimateGroup } from "react-simple-animate";
import {resetLoginStep} from "../../../Features/Misc/loginSlice";

// Images
import TileBG from "../../../assets/img/dashboard-tile-bg.png";
import IconSnoreBubble from "../../../assets/img/snore-bubble.svg";
import IconFace from "../../../assets/img/face.svg";
import IconThermostat from "../../../assets/img/thermostat.svg";
import IconSnore from "../../../assets/img/snore.svg";
import IconSleepMask from "../../../assets/img/sleep-mask.svg";
import IconNightClock from "../../../assets/img/night-clock.svg";


const buttonConfigs = {
    1: {
        icon: IconSnoreBubble,
        text: "Can't get to sleep",
        name: "Landing__watchButton cursor-pointer",
        // rowStyles: "row-start-3 row-end-12 xl:row-start-3 xl:row-end-18 p-2 xl:p-4 xl:hidden",
        // colStyles: "col-start-1 col-end-13  xl:col-start-1 lg:col-end-12",
    },
    2: {
        icon: IconFace,
        text: "Waking in the night",
        name: "Landing__watchButton cursor-pointer",
        // rowStyles: "row-start-3 row-end-12  xl:row-start-3 xl:row-end-18   p-2 xl:p-4",
        // colStyles: "col-start-13 col-end-25 lg:col-start-14 xl:col-start-1 xl:col-end-9",
    },
    3: {
        icon: IconThermostat,
        text: "Temperature",
        name: "Landing__readButton cursor-pointer",
        // rowStyles: "row-start-12 row-end-21 xl:row-start-3 xl:row-end-18 p-2 xl:p-4",
        // colStyles: "col-start-1 col-end-13 lg:col-end-12 xl:col-start-9 xl:col-end-17",
    },
    4: {
        icon: IconSnore,
        text: "Snoring/Sleep apnea",
        name: "Landing__learnButton",
        // rowStyles: "row-start-12 row-end-21 xl:row-start-3 xl:row-end-18 p-2 xl:p-4",
        // colStyles: "col-start-13 col-end-25 lg:col-start-14 xl:col-start-17 xl:col-end-25",
    },
    5: {
        icon: IconSleepMask,
        text: "Menopause",
        name: "Landing__learnButton",
        // rowStyles: "row-start-12 row-end-21 xl:row-start-3 xl:row-end-18 p-2 xl:p-4",
        // colStyles: "col-start-13 col-end-25 lg:col-start-14 xl:col-start-17 xl:col-end-25",
    },
    6: {
        icon: IconNightClock,
            text: "Shift Work",
            name: "Landing__learnButton",
        // rowStyles: "row-start-12 row-end-21 xl:row-start-3 xl:row-end-18 p-2 xl:p-4",
        // colStyles: "col-start-13 col-end-25 lg:col-start-14 xl:col-start-17 xl:col-end-25",
    },
    inactive: {
        icon: "ri-lock-2",
        text: "No active subscription.",
        name: "Landing__disabledButton",
        // rowStyles: "row-start-3 row-end-21 xl:row-start-3 xl:row-end-18 p-2 xl:p-4 cursor-default",
        // colStyles: "col-start-1 col-end-25 lg:col-start-5 lg:col-end-21 cursor-default",
    },
};

const LandingButton = ({ type, job }) => {
    const { icon, text, name, rowStyles, colStyles } = buttonConfigs[type];
    const dispatch = useDispatch()
    const animProps = {
        start: { opacity: 0 },
        end: { opacity: 1 },
    };

    const handleLogout = () => {
        dispatch(reset());
        dispatch(offCanvasReset());
        dispatch(navBarReset());
        dispatch(activeReset());
        dispatch(activeMediaReset());
        dispatch(resetLoginStep());
        dispatch(logOut());
        persistor.purge();

    };

    const handleOpenUrl = () => {
        window.open('https://www.kipmate.com/#contact', '_blank');
    };

    return (
        <div onClick={type !== "inactive" ? job : null} className={`${name} ${rowStyles}  ${colStyles}`}>
            <div
                style={{ backgroundImage: `url(${TileBG})` }}
                className={`Landing__watchButton__contents aspect-square bg-purple-slumber h-full rounded-xl bg-cover flex flex-col items-center justify-center ${
                    type !== 'inactive' ? 'cursor-pointer hover:opacity-80' : ''
                } transition-opacity duration-200`}
            >
                <AnimateGroup play>
                    <Animate {...animProps} sequenceIndex={0} duration={0.6}>
                        <img className="mb-3" src={icon} alt={`${text} Icon`} />
                    </Animate>
                    <Animate {...animProps} sequenceIndex={1} delay={0.1} duration={0.9}>
                        <p className={`text-white text-center text-xl md:text-2xl xl:text-3xl`}>{text}</p>
                    </Animate>
                    {type === "inactive" && (
                        <>
                            <Animate {...animProps} sequenceIndex={2} delay={0.2} duration={1.2}>
                                <div className="mt-4 flex flex-col sm:flex-row justify-center space-y-4 sm:space-y-0 sm:space-x-6 cursor-default">
                                    <button
                                        onClick={handleOpenUrl}
                                        className="bg-gold-accent hover:opacity-80 text-white text-lg font-semibold py-4 px-6 rounded transition-opacity duration-200 w-full sm:w-auto"
                                    >
                                        Contact us
                                    </button>

                                    <button
                                        onClick={handleLogout}
                                        className="bg-purple-dashboard hover:opacity-80 text-white text-lg font-semibold py-4 px-6 rounded transition-opacity duration-200 w-full sm:w-auto"
                                    >
                                        Log Out
                                    </button>
                                </div>
                            </Animate>
                        </>
                    )}
                </AnimateGroup>
            </div>
        </div>
    );
};

export default LandingButton;
